<template>
  <ControlContent :type="displayMode">
    <div id="kwizbot_widget"></div>
  </ControlContent>
</template>

<script>
import { computed, watchEffect, onMounted, nextTick, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import event from '@/helpers/widgetCustomEvent';

import ControlContent from './ControlContent.vue';

const changeControlState = function (store, actionData) {
  if (!actionData) {
    return;
  }

  const stateKeys = {
    'display-mode': 'currentDisplayMode',
    'theme-type': 'currentTheme',
    'button-mode': 'currentButtonMode',
    'icon-mode': 'currentIconMode',
    'title-parameter': 'currentTitle',
    'subtitle-parameter': 'currentSubTitle',
    'avatar-pose': 'currentAvatarPose',
    'avatar-scale': 'avatarScale.current',
    'title-image-url':'titleImageUrl',
    'bot-avatar-url':'botAvatarImageUrl',
    'bot-id':'botId',
    'launcher-img-src': 'launcherImgSrc',
    // 'custom-event': customEvent,
    'multi-channel-title': 'currentMultiChannelTitle',
    'viber-url': 'currentViberUrl',
    'telegram-url': 'currentTelegramUrl',
    'facebook-url': 'currentFacebookUrl',
    'whatsapp-url': 'currentWhatsappUrl',
    'timeout-mode': 'timeout_mode',
    'timeout-value': 'timeout_value',
    'preview-demo': 'preview_demo',
    'recognize-user-meta': 'recognize_user_meta',
    'widget-button-animation': 'widget_button_animation',
  };

  const stateKey = stateKeys[actionData.type];

  if (!stateKey) {
    return;
  }

  store.dispatch('control/setCurrentParam', {
    path: stateKey,
    value: actionData.value,
  });
};

export default {
  components: {
    ControlContent,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const displayMode = computed(() => {
      return store.state.control.currentDisplayMode;
    });

    const preInitActions = new Set();

    const widgetInitHandler = function () {
      store.dispatch('control/setIsWidgetInit', true);

      const actionsWithData = [...preInitActions].filter((action) => {
        return action && action.value !== null;
      });

      // actionsWithData.push({
      //   type: 'widget-locale',
      //   value: route.params.locale,
      // });



      actionsWithData.forEach((actionData) => {
        event.triggerCustomEvent(actionData);
        changeControlState(store, actionData);
      });

      preInitActions.clear();
    };

    onMounted(() => { 
      document.body.addEventListener('kw_init', widgetInitHandler);
    });

    onUnmounted(() => {
      document.body.removeEventListener('kw_init', widgetInitHandler);
    });

    const widgetActionEffect = function () {
      const actionData = store.state.control.widgetAction;
      const isWidgetInit = store.state.control.isWidgetInit;
      const stateData = JSON.parse(JSON.stringify(store.state.control))

      if (isWidgetInit) {
        event.triggerCustomEvent(actionData, stateData);
        changeControlState(store, actionData);
      } else {
        preInitActions.add(actionData);
      }
    };

    watchEffect(widgetActionEffect, {
      flush: 'sync',
    });

    onMounted(() => {
      nextTick(() => {
        (function (k, w, i, z, b, o, t) {
          k['KwizbotWidget'] = b;
          (k[b] =
            k[b] ||
            function () {
              w.head.insertAdjacentHTML(
                'beforeend',
                '<style type="text/css">.showAfterCssLoaded{display: none}</style>'
              );
              (k[b].q = k[b].q || []).push(arguments);
            }),
            (k[b].l = 1 * new Date());
          (o = w.createElement(i)), (t = w.getElementsByTagName(i)[0]);
          o.async = 1;
          o.src = z;
          t.parentNode.insertBefore(o, t);
        })(
          window,
          document,
          'script',
          `${process.env.VUE_APP_EMBED_URL}/kwjs.js`,
          'kw'
        );

        const options = {
          language_code: route.params.locale,
        }

        const botId =  store.state.control.botId;

        if (botId) {
          options.bot_id = botId;
        }

        window.kw('init', options);        
      });
    });

    return {
      displayMode,
    };
  },
};
</script>

<style lang="scss"></style>
